import { render } from "./PostCreate.vue?vue&type=template&id=5126b838&scoped=true"
import script from "./PostCreate.vue?vue&type=script&lang=js"
export * from "./PostCreate.vue?vue&type=script&lang=js"

import "./PostCreate.vue?vue&type=style&index=0&id=5126b838&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5126b838"]])

export default __exports__